const getApiBase = () => {
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return '/api';
  }
  return import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '/api';
};

const API_BASE = getApiBase();

function authHeaders() {
  const token = localStorage.getItem("candidate_token") ||
    sessionStorage.getItem("candidate_token") ||
    localStorage.getItem("erp_auth_token") ||
    sessionStorage.getItem("erp_auth_token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function generateQuestions({ type, role, difficulty, duration, persona }) {
  const res = await fetch(`${API_BASE}/ai-engine/generate-questions`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ type, role, difficulty, duration, persona }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to generate questions");
  return data.data.questions;
}

export async function getFollowUp({ question, answer, persona }) {
  const res = await fetch(`${API_BASE}/ai-engine/follow-up`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ question, answer, persona }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to get follow-up");
  return data.data;
}

export async function evaluateInterview({ transcript, type, role }) {
  const res = await fetch(`${API_BASE}/ai-engine/evaluate`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ transcript, type, role }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to evaluate interview");
  return data.data;
}

export async function saveSession({ id, type, role, difficulty, persona, duration, status, transcript, evaluation }) {
  const res = await fetch(`${API_BASE}/ai-session`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ id, type, role, difficulty, persona, duration, status, transcript, evaluation }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to save session");
  return data.data;
}

export async function getHistory() {
  const res = await fetch(`${API_BASE}/ai-session`, {
    method: "GET",
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to load interview history");
  return data.data;
}
export async function uploadResume(file) {
  const token = localStorage.getItem("erp_auth_token");
  const formData = new FormData();
  formData.append("file", file);
  const res = await fetch(`${API_BASE}/ai-resume/upload`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to upload resume");
  return data.data;
}

export async function analyzeResume({ resumeId, text }) {
  const res = await fetch(`${API_BASE}/ai-resume/analyze`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ resumeId, text }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to analyze resume");
  return data.data;
}

export async function startScreening({ applicationId, candidateId }) {
  const res = await fetch(`${API_BASE}/ai-session/start-screening`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ application_id: applicationId, candidate_id: candidateId }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to start AI screening");
  return data.data;
}

export async function completeScreening({ applicationId, transcript, answers, candidateId }) {
  const res = await fetch(`${API_BASE}/ai-session/complete-screening`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ application_id: applicationId, transcript, answers, candidateId }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to complete AI screening");
  return data.data;
}

export async function getScreeningStatus(applicationId) {
  const res = await fetch(`${API_BASE}/ai-session/screening-status?application_id=${encodeURIComponent(applicationId)}`, {
    method: "GET",
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to get screening status");
  return data.data;
}

export async function getNextQuestion({ applicationId, history, questionIndex, maxQuestions = 5 }) {
  const res = await fetch(`${API_BASE}/ai-session/next-question`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({
      application_id: applicationId,
      history,
      question_index: questionIndex,
      max_questions: maxQuestions
    }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Failed to generate next question");
  return data.data;
}